export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_POTENCIA_160_4V_BANNER_01.d429fcab.jpg";